import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getProductsByQuery } from '../../../../../Services/ProductList.Service';
import inputDelay from '../../../../../Services/inputDelay';
import useOutsideClickAction from '../../../../../Services/useOutsideClickAction';
import { translate } from '../../../../../Services/translation';
import { add as addToCartService } from '../../../../../Services/Cart.service';
import { receive } from '../../../../../Actions/Cart.action';
import { catchError } from '../../../../../Actions/Error.action';
import { loadError } from '../../../../../Actions/Cart.action';
import { clearSubmitError } from '../../../../../Actions/Checkout.action';
import {
  isKlarnaPayment,
  klarnaResume,
  klarnaSuspend,
} from '../../../../../Utils/klarna';
import { cn } from '../../../../../Utils/cn';

const CheckoutCartAddToCart = ({ checkout, cart }) => {
  const dispatch = useDispatch();
  const { payload } = checkout || {};
  const { isBusinessCustomer, selectedPaymentMethod } = payload || {};

  const dropdownRef = useRef();
  const dropdownContainerRef = useRef();

  const [active, setActive] = useState();
  const [list, setList] = useState();
  const [value, setValue] = useState('');

  const handleSearch = inputDelay(
    (query) =>
      getProductsByQuery(query).then((results) => {
        if (results?.length) {
          setList(
            results.map((result) => ({
              id: result?.item?.selectedVariant?.id,
              name: result?.name,
            }))
          );
        }
        setActive(true);
      }),
    250
  );

  const handleAddToCart = async (item) => {
    if (!cart?.orderRows?.length) {
      dispatch(clearSubmitError());
    }
    setActive(false);
    setList([]);
    setValue('');
    if (isKlarnaPayment(selectedPaymentMethod)) {
      klarnaSuspend();
    }
    try {
      const cartResponse = await addToCartService({
        articleNumber: item?.id,
        quantity: 1,
      });
      dispatch(receive(cartResponse));
    } catch (error) {
      dispatch(catchError(error, (err) => loadError(err)));
    } finally {
      if (isKlarnaPayment(selectedPaymentMethod)) {
        klarnaResume();
      }
    }
  };

  useOutsideClickAction(dropdownContainerRef, () => setActive(false));

  useEffect(() => {
    const handleFocusOut = (event) => {
      if (!dropdownContainerRef.current?.contains(event.relatedTarget)) {
        // setActive(false);
        setTimeout(() => {
          setActive(false);
        }, 0);
      }
    };
    const container = dropdownContainerRef.current;
    if (container) {
      container.addEventListener('focusout', handleFocusOut);
      return () => container.removeEventListener('focusout', handleFocusOut);
    }
  }, []);

  if (!isBusinessCustomer) {
    return null;
  }

  return (
    <div className="relative mb-4" ref={dropdownContainerRef}>
      <label
        htmlFor="product-search"
        className="body-sm leading-base text-label mb-1 inline-block"
      >
        {translate('checkout.addproduct')}
      </label>
      <input
        id="product-search"
        className="form__input"
        type="text"
        placeholder={translate('checkout.productnumber')}
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
          handleSearch(event.target.value);
        }}
        onFocus={() => setActive(true)}
      />
      {!!list?.length && (
        <ul
          className={cn('border-border-primary absolute z-10 mt-2 max-h-64 w-full overflow-y-auto rounded-2xl border bg-white px-4 py-2 shadow', active ? 'block' : 'hidden')}
          ref={dropdownRef}
        >
          {list.map((item) => (
            <li
              className="border-b-border-primary border-b last:border-none"
              key={item?.id}
            >
              <button
                className="link-inverted w-full py-4 text-left leading-snug"
                type="button"
                onClick={() => handleAddToCart(item)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {`${item?.name} (${item?.id})`}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CheckoutCartAddToCart;
